import React from 'react'

export default function Ganday() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.5164 7.14319C1.32829 3.21545 3.8263 1.02782 7.72282 0.366909C10.6032 -0.121503 13.4847 -0.12767 16.3602 0.380652C20.3723 1.08984 22.7841 3.40504 23.5524 7.39215C24.1461 10.4736 24.1554 13.5879 23.5431 16.6663C22.7218 20.5669 20.1593 22.9747 16.2772 23.6331C13.3968 24.1215 10.5153 24.1277 7.63977 23.6193C3.62772 22.9102 1.20521 20.4794 0.436861 16.4923C-0.186982 13.3905 -0.126933 10.2566 0.5164 7.14319Z"
        fill="url(#paint0_linear_2645_12881)"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.9969 9.5908C17.6663 5.72656 13.4551 3.6726 9.59086 5.00317C8.07508 5.52509 6.83754 6.49084 5.97392 7.70431L5.68567 6.3482C5.61677 6.02407 5.29816 5.81717 4.97403 5.88606C4.6499 5.95496 4.443 6.27357 4.51189 6.5977L5.10718 9.39829C5.17607 9.72242 5.49468 9.92933 5.81881 9.86043L8.6194 9.26515C8.94353 9.19625 9.15044 8.87764 9.08154 8.55351C9.01265 8.22938 8.69404 8.02247 8.36991 8.09137L6.95763 8.39156C7.68104 7.37864 8.7151 6.57386 9.98154 6.13779C13.2192 5.02299 16.7475 6.74387 17.8623 9.98148C18.9771 13.2191 17.2562 16.7474 14.0186 17.8622C10.781 18.977 7.25265 17.2561 6.13785 14.0185C6.02996 13.7052 5.68851 13.5387 5.37519 13.6466C5.06188 13.7544 4.89534 14.0959 5.00322 14.4092C6.33379 18.2735 10.545 20.3274 14.4093 18.9968C18.2735 17.6663 20.3275 13.455 18.9969 9.5908ZM12.2 9.2C12.2 8.86863 11.9314 8.6 11.6 8.6C11.2687 8.6 11 8.86863 11 9.2V12.4C11 12.6006 11.1003 12.788 11.2672 12.8992L13.6672 14.4992C13.9429 14.683 14.3155 14.6085 14.4993 14.3328C14.6831 14.0571 14.6086 13.6846 14.3329 13.5008L12.2 12.0789V9.2Z"
        fill="#FEFFFF"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_2645_12881"
          x1="0"
          y1="0"
          x2="24"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8E4CFF"></stop>
          <stop offset="1" stopColor="#7729FF"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}
